<div style="grid-column: 1 / -1; display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; margin-bottom: 20px;">

  <div>
    <p class="dark-gray no-margin mb-5">Dénomination du collège</p>
    <p class="dark-blue bold">{{college.collegeType[0]}}</p>
  </div>

  <div>
    <p class="dark-gray no-margin mb-5">Libellé du collège</p>
    <p class="dark-blue bold">{{college.collegeName}}</p>
  </div>

  <div style="grid-column: 1 / -1;">
    <p class="dark-gray no-margin mb-5">Effectif du collège</p>
    <p class="dark-blue bold" *ngFor="let item of college.composition">
      - {{item == 'Autres' ? 'Autres (' + college.detail + ')' : item}}
    </p>
  </div>
  <!-- <div style="grid-column: 1 / -1;">
    <p class="dark-blue no-margin mb-5">Composition précise <span class="red">*</span></p>
    <div class="flex content-between mb-10"
      style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; margin-bottom: 20px;">
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Workers)" 
          (change)="toggleComposition(lineupOptions.Workers)"> Ouvriers
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Employees)" 
          (change)="toggleComposition(lineupOptions.Employees)"> Employés
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Technicians)" 
          (change)="toggleComposition(lineupOptions.Technicians)"> Techniciens
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Supervisors)" 
          (change)="toggleComposition(lineupOptions.Supervisors)"> Agent de maîtrise
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Engineers)" 
          (change)="toggleComposition(lineupOptions.Engineers)"> Ingénieur
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Executives)" 
          (change)="toggleComposition(lineupOptions.Executives)"> Cadres
      </label>
      <div class="flex gap-10" style="grid-column: span 2;">
        <label class="flex align-items-center gap-5 pointer dark-blue" style="white-space: nowrap;">
          <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Other)" 
            (change)="toggleComposition(lineupOptions.Other)"> Autres (préciser) :
        </label>
        <input type="text" class="text-md dark-blue title-input" [(ngModel)]="college.detail"
          (ngModelChange)="onCollegesChange()">
      </div>
    </div>
  </div> -->

  <div>
    <p class="dark-gray no-margin mb-5">Siège titulaires</p>
    <p class="dark-blue bold">{{college.seats}}</p>
  </div>

  <div>
    <p class="dark-gray no-margin mb-5">Siège suppléants</p>
    <p class="dark-blue bold">{{college.substituteSeats}}</p>
  </div>

  <div style="grid-column: 1 / -1;">
    <p class="dark-blue no-margin mb-5 bold"><span class="circle"></span>Effectif et répartition par sexe</p>
    <div class="flex content-between mb-10"
      style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px;">
      <div>
        <p class="dark-gray no-margin mb-5">Effectif du collège</p>
        <p class="dark-blue bold">{{college.lineup}}</p>
      </div>
      <div>
        <p class="dark-gray no-margin mb-5">Effectif Femmes</p>
        <p class="dark-blue bold">{{college.genderDistribution[0]}}</p>
      </div>
      <div>
        <p class="dark-gray no-margin mb-5">Effectif Hommes</p>
        <p class="dark-blue bold">{{college.genderDistribution[1]}}</p>
      </div>
    </div>
  </div>

  <div>
    <p class="dark-gray no-margin mb-5">Pourcentage Femmes</p>
    <p class="dark-blue bold">{{womenPercentage}}</p>
  </div>
  <div>
    <p class="dark-gray no-margin mb-5">Pourcentage Hommes</p>
    <p class="dark-blue bold">{{menPercentage}}</p>
  </div>

  <div>
    <p class="dark-gray no-margin mb-5">Proportion Femmes</p>
    <p class="dark-blue bold">{{womenSeatsCount}}</p>
  </div>
  <div>
    <p class="dark-gray no-margin mb-5">Proportion Hommes</p>
    <p class="dark-blue bold">{{menSeatsCount}}</p>
  </div>

  <div>
    <p class="dark-gray no-margin mb-5">Proportion Femmes</p>
    <p class="dark-blue bold">{{womenSubstituteSeatsCount}}</p>
  </div>
  <div>
    <p class="dark-gray no-margin mb-5">Proportion Hommes</p>
    <p class="dark-blue bold">{{menSubstituteSeatsCount}}</p>
  </div>

  <p style="grid-column: 1 / -1;" class="dark-blue no-margin mb-5 bold">
    <span class="circle"></span>Ce scrutin fait-il suite à une décision de justice annulant un précédent scrutin ?
  </p>
  <p class="dark-blue bold">{{courtDecisionText ? 'Oui : ' + college.cancelledElection : 'Non'}}</p>
</div>